import { produce } from 'immer';
import { ACTIVE_MODULES_GET } from '../actions/modules';
import { MODULES } from '../../../utils/modules';

const initialState = {
  modules: Object.values(MODULES),
};

const modulesReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ACTIVE_MODULES_GET._SUCCESS: {
        const { response } = action;
        const activeModules = Object.keys(response).filter((k) => response[k]);
        draft.modules = [...activeModules];
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default modulesReducer;
